import { Navigate } from "react-router-dom";
import { useAppSelector } from "../Redux/hooks";

const PublicRoute = ({ element: Element }) => {
  const isAuthenticated = useAppSelector(
    (state) => state.auth.isAuthenticated
  );
  return !isAuthenticated ? (
    <Element />
  ) : (
    <Navigate to="/dashboard" />
  );
};

export default PublicRoute;
